webpackJsonp([160],{

/***/ 1293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingExaminationInternRecordDetail_vue__ = __webpack_require__(3051);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13109267_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingExaminationInternRecordDetail_vue__ = __webpack_require__(5649);
function injectStyle (ssrContext) {
  __webpack_require__(5647)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13109267"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingExaminationInternRecordDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13109267_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingExaminationInternRecordDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* unused harmony export getFileExtension */
/* unused harmony export getCourseContentTypeByFile */
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2
  // CONTENT_TYPE_DOCUMENT: 3,
};

var opts = {
  contentTypeMaps: [{ value: consts.CONTENT_TYPE_IMAGE, label: '图片' }, { value: consts.CONTENT_TYPE_VIDEO, label: '视频' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  tip: '支持 JPG、PNG，可上传多张，单个最大 20MB'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 1,
  maxSizeMB: 1024,
  tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB'
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseContentTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE;
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO;
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0;
}

function getCourseUploadConfig(contentType) {
  if (!contentType) {
    var configs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
      return COURSE_UPLOAD_TYPE_CONFIGS[type];
    });
    return {
      accept: configs.reduce(function (result, item) {
        return result.concat(item.accept);
      }, []),
      extensions: configs.reduce(function (result, item) {
        return result.concat(item.extensions);
      }, []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(function (item) {
        return item.maxSizeMB;
      })),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个'
    };
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE];
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var contentType = getCourseContentTypeByFile(file);
  if (!contentType) {
    return {
      valid: false,
      contentType: contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(contentType);
  var currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0;
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType: contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(function (item) {
        return Number(item.content_type || item.type || currentContentType) !== contentType;
      })
    };
  }

  return {
    valid: true,
    contentType: contentType,
    message: '',
    replaceAll: currentFiles.some(function (item) {
      return Number(item.content_type || item.type || currentContentType) !== contentType;
    })
  };
}

/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["d"] = createOptionUuid;
/* harmony export (immutable) */ __webpack_exports__["c"] = createDefaultQuestionOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOptionLetter;
/* harmony export (immutable) */ __webpack_exports__["p"] = resetQuestionAnswerByType;
/* harmony export (immutable) */ __webpack_exports__["k"] = isChoiceQuestion;
/* harmony export (immutable) */ __webpack_exports__["l"] = isNumericAnswer;
/* harmony export (immutable) */ __webpack_exports__["j"] = getQuestionTypeLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getQuestionStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["h"] = getQuestionStatusType;
/* harmony export (immutable) */ __webpack_exports__["f"] = getQuestionStatusActions;
/* harmony export (immutable) */ __webpack_exports__["m"] = isQuestionRelationEditLocked;
/* unused harmony export isQuestionBaned */
/* harmony export (immutable) */ __webpack_exports__["n"] = isQuestionUsedOrBaned;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQuestionKnowledgeQueryParams;
/* harmony export (immutable) */ __webpack_exports__["i"] = getQuestionSubmitPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__ = __webpack_require__(1505);



var consts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["b" /* consts */], {
  QUESTION_TYPE_SINGLE: 1, // 单选题
  QUESTION_TYPE_MULTI: 2, // 多选题
  QUESTION_TYPE_FILL_BLANK: 3, // 填空题

  QUESTION_STATUS_NEW: 1, // 新创建
  QUESTION_STATUS_USING: 2, // 使用中
  QUESTION_STATUS_UNUSED: 3, // 未使用
  QUESTION_STATUS_BANNED: 4 // 已作废
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: [{ value: consts.QUESTION_STATUS_NEW, label: '新创建' }, { value: consts.QUESTION_STATUS_UNUSED, label: '未使用' }, { value: consts.QUESTION_STATUS_USING, label: '使用中' }, { value: consts.QUESTION_STATUS_BANNED, label: '已作废' }],
  questionTypeMaps: [{ value: consts.QUESTION_TYPE_SINGLE, label: '单选题' }, { value: consts.QUESTION_TYPE_MULTI, label: '多选题' }, { value: consts.QUESTION_TYPE_FILL_BLANK, label: '填空题' }]
};

function createOptionUuid() {
  return 'opt' + Math.random().toString(16).slice(2) + Date.now();
}

function createDefaultQuestionOptions() {
  return ['A', 'B', 'C', 'D'].map(function (letter) {
    return {
      uuid: createOptionUuid(),
      title: '\u9009\u9879' + letter
    };
  });
}

function getOptionLetter(index) {
  return String.fromCharCode(65 + index);
}

function resetQuestionAnswerByType(type) {
  return Number(type) === consts.QUESTION_TYPE_MULTI ? [] : '';
}

function isChoiceQuestion(type) {
  return [consts.QUESTION_TYPE_SINGLE, consts.QUESTION_TYPE_MULTI].includes(Number(type));
}

function isNumericAnswer(value) {
  return (/^-?\d+(\.\d+)?$/.test(String(value).trim())
  );
}

function getQuestionTypeLabel(value) {
  var item = opts.questionTypeMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusLabel(value) {
  var item = opts.statusMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusType(status) {
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
      return 'success';
    case consts.QUESTION_STATUS_USING:
      return 'primary';
    case consts.QUESTION_STATUS_BANNED:
      return 'default';
    default:
      return 'warning';
  }
}

function getQuestionStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!isSuperAdmin) {
    return [];
  }
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
    case consts.QUESTION_STATUS_NEW:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingQuestion', successText: '作废成功' }];
    case consts.QUESTION_STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingQuestion', successText: '激活成功' }];
    default:
      return [];
  }
}

function isQuestionRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.QUESTION_STATUS_UNUSED, consts.QUESTION_STATUS_USING, consts.QUESTION_STATUS_BANNED].includes(Number(status));
}

function isQuestionBaned(id, status) {
  return Number(id) > 0 && Number(status) === consts.QUESTION_STATUS_BANNED;
}

function isQuestionUsedOrBaned(id, status) {
  return Number(id) > 0 && (Number(status) === consts.QUESTION_STATUS_BANNED || Number(status) === consts.QUESTION_STATUS_USING);
}

function buildQuestionKnowledgeQueryParams(form) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["a" /* buildCourseKnowledgeQueryParams */])(form);
}

function getQuestionSubmitPayload(form) {
  var payload = {
    target_usertype: form.target_usertype,
    is_common: form.is_common,
    customerid: Number(form.is_common) === consts.IS_COMMON_SHARED ? 0 : form.customerid,
    training_knowledge_id: form.training_knowledge_id,
    question_type: form.question_type,
    question_json: {
      title: form.title,
      sample_files: form.sample_files || [],
      question_analysis: {
        analysis_text: form.analysis_text || '',
        analysis_files: form.analysis_files || []
      },
      standard_answer: form.standard_answer
    }
  };

  if (isChoiceQuestion(form.question_type)) {
    payload.question_json.options = form.options || [];
  }

  return payload;
}

/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingInstructionSubHeading',
  props: {
    title: {
      type: String,
      required: true
    },
    entityId: {
      type: [Number, String],
      default: null
    },
    fallbackPath: {
      type: String,
      default: '/training/instruction'
    }
  },
  computed: {
    hasEntityId: function hasEntityId() {
      return this.entityId !== null && this.entityId !== undefined && this.entityId !== '';
    }
  },
  methods: {
    onBack: function onBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push(this.fallbackPath);
    }
  }
});

/***/ }),

/***/ 1608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingMediaPreview',
  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      viewer: {
        visible: false,
        index: 0
      }
    };
  },

  computed: {
    normalizedFiles: function normalizedFiles() {
      return (this.files || []).filter(function (file) {
        return file && file.url && (file.type === 'img' || file.type === 'video');
      });
    },
    viewerIndex: function viewerIndex() {
      return this.viewer.index;
    },
    activeFile: function activeFile() {
      return this.normalizedFiles[this.viewerIndex] || null;
    },
    canGoPrev: function canGoPrev() {
      return this.viewerIndex > 0;
    },
    canGoNext: function canGoNext() {
      return this.viewerIndex < this.normalizedFiles.length - 1;
    }
  },
  mounted: function mounted() {
    document.addEventListener('keyup', this.onKeyup);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyup);
  },

  methods: {
    fileKey: function fileKey(file, index) {
      return file.uid || file.url || index;
    },
    openViewer: function openViewer(index) {
      if (index < 0 || index >= this.normalizedFiles.length) {
        return;
      }
      this.viewer.index = index;
      this.viewer.visible = true;
    },
    closeViewer: function closeViewer() {
      this.viewer.visible = false;
    },
    onViewerOpened: function onViewerOpened() {
      this.pauseVideo();
    },
    onViewerClosed: function onViewerClosed() {
      this.pauseVideo();
      this.viewer.index = 0;
    },
    viewIndex: function viewIndex(index) {
      if (index === this.viewerIndex || index < 0 || index >= this.normalizedFiles.length) {
        return;
      }
      this.pauseVideo();
      this.viewer.index = index;
    },
    viewPrev: function viewPrev() {
      if (!this.canGoPrev) {
        return;
      }
      this.viewIndex(this.viewerIndex - 1);
    },
    viewNext: function viewNext() {
      if (!this.canGoNext) {
        return;
      }
      this.viewIndex(this.viewerIndex + 1);
    },
    pauseVideo: function pauseVideo() {
      var player = this.$refs.videoPlayer;
      if (player && typeof player.pause === 'function') {
        player.pause();
      }
    },
    onKeyup: function onKeyup(event) {
      if (!this.viewer.visible) {
        return;
      }
      if (event.keyCode === 37) {
        this.viewPrev();
      } else if (event.keyCode === 39) {
        this.viewNext();
      }
    }
  }
});

/***/ }),

/***/ 1612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionSubHeading_vue__ = __webpack_require__(1550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67108e77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionSubHeading_vue__ = __webpack_require__(1668);
function injectStyle (ssrContext) {
  __webpack_require__(1666)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67108e77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionSubHeading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67108e77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionSubHeading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c279ecb4", content, true, {});

/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-sub-heading[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;margin-bottom:16px}.training-instruction-sub-heading__back[data-v-67108e77]{-ms-flex-negative:0;flex-shrink:0}.training-instruction-sub-heading__title[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;font-size:20px;font-weight:600;color:#303133;line-height:1.4}.training-instruction-sub-heading__title-text[data-v-67108e77]{min-width:0}.training-instruction-sub-heading__id-badge[data-v-67108e77]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:500;line-height:20px;color:#606266;background:#f4f4f5;border:1px solid #e9e9eb;font-variant-numeric:tabular-nums}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingInstructionSubHeading.vue"],"names":[],"mappings":"AACA,mDAAmD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,kBAAkB,CACpM,AACD,yDAAyD,oBAAoB,aAAa,CACzF,AACD,0DAA0D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,mBAAmB,eAAe,SAAS,eAAe,gBAAgB,cAAc,eAAe,CAC/R,AACD,+DAA+D,WAAW,CACzE,AACD,6DAA6D,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,oBAAoB,cAAc,gBAAgB,kBAAkB,eAAe,gBAAgB,iBAAiB,cAAc,mBAAmB,yBAAyB,iCAAiC,CACvZ","file":"TrainingInstructionSubHeading.vue","sourcesContent":["\n.training-instruction-sub-heading[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;margin-bottom:16px\n}\n.training-instruction-sub-heading__back[data-v-67108e77]{-ms-flex-negative:0;flex-shrink:0\n}\n.training-instruction-sub-heading__title[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;font-size:20px;font-weight:600;color:#303133;line-height:1.4\n}\n.training-instruction-sub-heading__title-text[data-v-67108e77]{min-width:0\n}\n.training-instruction-sub-heading__id-badge[data-v-67108e77]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:500;line-height:20px;color:#606266;background:#f4f4f5;border:1px solid #e9e9eb;font-variant-numeric:tabular-nums\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-instruction-sub-heading"},[_c('el-button',{staticClass:"training-instruction-sub-heading__back",attrs:{"icon":"el-icon-arrow-left","circle":""},on:{"click":_vm.onBack}}),_vm._v(" "),_c('h2',{staticClass:"training-instruction-sub-heading__title"},[_c('span',{staticClass:"training-instruction-sub-heading__title-text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.hasEntityId)?_c('span',{staticClass:"training-instruction-sub-heading__id-badge"},[_vm._v("ID："+_vm._s(_vm.entityId))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COURSE_FILE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["j"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["k"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* harmony export (immutable) */ __webpack_exports__["i"] = getFileExtension;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseFileTypeByFile;
/* harmony export (immutable) */ __webpack_exports__["h"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["m"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);





var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  INTERN_SCOPE_ALL: 1, // 全部实习生
  INTERN_SCOPE_SPECIFIC: 2, // 指定实习生

  KNOWLEDGE_STATUS_ACTIVE: 2
};

var COURSE_FILE_TYPES = {
  IMAGE: 'img',
  VIDEO: 'video',
  PDF: 'pdf',
  PPT: 'ppt',
  WORD: 'word',
  EXCEL: 'excel'
};

var opts = {
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }],
  InternScopeMaps: [{ value: consts.INTERN_SCOPE_ALL, label: '全部' }, { value: consts.INTERN_SCOPE_SPECIFIC, label: '指定' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineInternTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banInternTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeInternTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  label: '图片'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 0,
  maxSizeMB: 1024,
  label: '视频'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.PDF, {
  accept: ['application/pdf'],
  extensions: ['pdf'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'PDF'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.PPT, {
  accept: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  extensions: ['ppt', 'pptx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'PPT'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.WORD, {
  accept: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  extensions: ['doc', 'docx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'Word'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.EXCEL, {
  accept: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  extensions: ['xls', 'xlsx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'Excel'
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseFileTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0) {
    return COURSE_FILE_TYPES.IMAGE;
  }
  if (type.indexOf('video/') === 0) {
    return COURSE_FILE_TYPES.VIDEO;
  }
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_FILE_TYPES).some(function (key) {
    return COURSE_FILE_TYPES[key] === type;
  })) {
    return type;
  }

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).find(function (fileType) {
    var config = COURSE_UPLOAD_TYPE_CONFIGS[fileType];
    return config.accept.includes(type) || config.extensions.includes(ext);
  }) || '';
}

function getCourseUploadConfig(fileType) {
  if (fileType && COURSE_UPLOAD_TYPE_CONFIGS[fileType]) {
    var config = COURSE_UPLOAD_TYPE_CONFIGS[fileType];
    var maxSizeLabel = config.maxSizeMB >= 1024 ? (config.maxSizeMB / 1024).toFixed(config.maxSizeMB % 1024 === 0 ? 0 : 1) + 'GB' : config.maxSizeMB + 'MB';
    var maxFilesLabel = config.maxFiles > 0 ? '\u6700\u591A ' + config.maxFiles + ' \u4E2A' : '可上传多个';

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, {
      tip: '\u652F\u6301\u4E0A\u4F20' + config.label + '\uFF0C' + maxFilesLabel + '\uFF0C\u5355\u4E2A\u6700\u5927 ' + maxSizeLabel
    });
  }

  var configs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
    return COURSE_UPLOAD_TYPE_CONFIGS[type];
  });
  return {
    accept: configs.reduce(function (result, item) {
      return result.concat(item.accept);
    }, []),
    extensions: configs.reduce(function (result, item) {
      return result.concat(item.extensions);
    }, []),
    maxFiles: 0,
    maxSizeMB: Math.max.apply(null, configs.map(function (item) {
      return item.maxSizeMB;
    })),
    tip: '支持图片、视频、PDF、PPT、Word、Excel，可上传多个文件，单个文件大小按类型限制'
  };
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var fileType = getCourseFileTypeByFile(file);
  if (!fileType) {
    return {
      valid: false,
      fileType: fileType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(fileType);
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  var currentTypeCount = Array.isArray(currentFiles) ? currentFiles.filter(function (item) {
    return getCourseFileTypeByFile(item) === fileType;
  }).length : 0;
  if (config.maxFiles > 0 && currentTypeCount >= config.maxFiles) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  return {
    valid: true,
    fileType: fileType,
    message: '',
    replaceAll: false
  };
}

/***/ }),

/***/ 1807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingMediaPreview_vue__ = __webpack_require__(1608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b0b448_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingMediaPreview_vue__ = __webpack_require__(1812);
function injectStyle (ssrContext) {
  __webpack_require__(1808)
  __webpack_require__(1810)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94b0b448"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingMediaPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b0b448_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingMediaPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1808:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1809);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1390a59c", content, true, {});

/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-media-preview[data-v-94b0b448]{margin-top:10px}.training-media-preview__grid[data-v-94b0b448]{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:10px;max-width:640px}.training-media-preview__item[data-v-94b0b448]{position:relative;aspect-ratio:1;border-radius:8px;overflow:hidden;cursor:pointer;background:#f2f2f2;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.08);box-shadow:0 2px 8px rgba(0,0,0,.08)}.training-media-preview__thumb[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}.training-media-preview__video[data-v-94b0b448]{position:relative;width:100%;height:100%;background:#eef2f7}.training-media-preview__video-placeholder[data-v-94b0b448]{width:100%;height:100%;color:#c0c4cc;font-size:28px}.training-media-preview__play-overlay[data-v-94b0b448],.training-media-preview__video-placeholder[data-v-94b0b448]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.training-media-preview__play-overlay[data-v-94b0b448]{position:absolute;inset:0;background:rgba(15,23,42,.12)}.training-media-preview__play-overlay i[data-v-94b0b448]{width:44px;height:44px;border-radius:50%;background:rgba(64,158,255,.88);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:24px;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.18);box-shadow:0 4px 12px rgba(0,0,0,.18)}.training-media-preview__viewer[data-v-94b0b448]{position:relative;width:100%;height:100vh;background:rgba(0,0,0,.92);overflow:hidden}.training-media-preview__viewer-close[data-v-94b0b448]{position:absolute;top:0;right:0;z-index:2003;background-color:hsla(0,0%,100%,.1);padding:30px;border:0;border-radius:0 0 0 100%;cursor:pointer}.training-media-preview__viewer-close[data-v-94b0b448]:hover{background-color:hsla(0,0%,100%,.2)}.training-media-preview__viewer-close i[data-v-94b0b448]{color:#fff;font-size:18px}.training-media-preview__viewer-counter[data-v-94b0b448]{position:absolute;top:10px;left:10px;z-index:2002;color:#909399;text-shadow:0 0 2px #000}.training-media-preview__viewer-counter-current[data-v-94b0b448]{font-size:22px;color:#fff}.training-media-preview__viewer-counter-total[data-v-94b0b448]{font-size:14px}.training-media-preview__viewer-body[data-v-94b0b448]{width:100%;height:calc(100% - 72px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:40px 72px 0;-webkit-box-sizing:border-box;box-sizing:border-box}.training-media-preview__viewer-image[data-v-94b0b448]{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.training-media-preview__viewer-video[data-v-94b0b448]{max-width:100%;max-height:100%;background:#000}.training-media-preview__viewer-nav[data-v-94b0b448]{z-index:2002}.training-media-preview__viewer-navbar[data-v-94b0b448]{position:absolute;left:0;right:0;bottom:0;z-index:2002;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:12px 16px 16px;overflow-x:auto;background:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.55)),to(transparent));background:linear-gradient(0deg,rgba(0,0,0,.55),transparent)}.training-media-preview__viewer-nav-item[data-v-94b0b448]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:56px;height:56px;border-radius:4px;overflow:hidden;cursor:pointer;opacity:.65;border:2px solid transparent;background:hsla(0,0%,100%,.08)}.training-media-preview__viewer-nav-item.is-active[data-v-94b0b448]{opacity:1;border-color:#409eff}.training-media-preview__viewer-nav-item img[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}.training-media-preview__viewer-nav-video[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:22px}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingMediaPreview.vue"],"names":[],"mappings":"AACA,yCAAyC,eAAe,CACvD,AACD,+CAA+C,aAAa,0DAA4D,SAAS,eAAe,CAC/I,AACD,+CAA+C,kBAAkB,eAAe,kBAAkB,gBAAgB,eAAe,mBAAmB,6CAA8C,oCAAqC,CACtO,AACD,gDAAgD,WAAW,YAAY,oBAAoB,iBAAiB,aAAa,CACxH,AACD,gDAAgD,kBAAkB,WAAW,YAAY,kBAAkB,CAC1G,AACD,4DAA4D,WAAW,YAAY,AAA2L,cAAc,cAAc,CACzS,AACD,mHAFmF,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,sBAAuB,CAG7Q,AADD,uDAAuD,kBAAkB,QAAQ,AAA2L,6BAA8B,CACzS,AACD,yDAAyD,WAAW,YAAY,kBAAkB,gCAAiC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,eAAe,8CAA+C,qCAAsC,CAC5a,AACD,iDAAiD,kBAAkB,WAAW,aAAa,2BAA4B,eAAe,CACrI,AACD,uDAAuD,kBAAkB,MAAM,QAAQ,aAAa,oCAAuC,aAAa,SAAS,yBAAyB,cAAc,CACvM,AACD,6DAA6D,mCAAsC,CAClG,AACD,yDAAyD,WAAW,cAAc,CACjF,AACD,yDAAyD,kBAAkB,SAAS,UAAU,aAAa,cAAc,wBAAwB,CAChJ,AACD,iEAAiE,eAAe,UAAU,CACzF,AACD,+DAA+D,cAAc,CAC5E,AACD,sDAAsD,WAAW,yBAAyB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,oBAAoB,8BAA8B,qBAAqB,CAC3V,AACD,uDAAuD,eAAe,gBAAgB,sBAAsB,kBAAkB,CAC7H,AACD,uDAAuD,eAAe,gBAAgB,eAAe,CACpG,AACD,qDAAqD,YAAY,CAChE,AACD,wDAAwD,kBAAkB,OAAO,QAAQ,SAAS,aAAa,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,uBAAuB,gBAAgB,+FAAoG,4DAAiE,CAC3b,AACD,0DAA0D,mBAAmB,kBAAkB,cAAc,WAAW,YAAY,kBAAkB,gBAAgB,eAAe,YAAa,6BAA6B,8BAAiC,CAC/P,AACD,oEAAoE,UAAU,oBAAoB,CACjG,AACD,8DAA8D,WAAW,YAAY,oBAAoB,iBAAiB,aAAa,CACtI,AACD,2DAA2D,WAAW,YAAY,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,cAAc,CACrS","file":"TrainingMediaPreview.vue","sourcesContent":["\n.training-media-preview[data-v-94b0b448]{margin-top:10px\n}\n.training-media-preview__grid[data-v-94b0b448]{display:grid;grid-template-columns:repeat(auto-fill, minmax(120px, 1fr));gap:10px;max-width:640px\n}\n.training-media-preview__item[data-v-94b0b448]{position:relative;aspect-ratio:1;border-radius:8px;overflow:hidden;cursor:pointer;background:#f2f2f2;-webkit-box-shadow:0 2px 8px rgba(0,0,0,0.08);box-shadow:0 2px 8px rgba(0,0,0,0.08)\n}\n.training-media-preview__thumb[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block\n}\n.training-media-preview__video[data-v-94b0b448]{position:relative;width:100%;height:100%;background:#eef2f7\n}\n.training-media-preview__video-placeholder[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#c0c4cc;font-size:28px\n}\n.training-media-preview__play-overlay[data-v-94b0b448]{position:absolute;inset:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:rgba(15,23,42,0.12)\n}\n.training-media-preview__play-overlay i[data-v-94b0b448]{width:44px;height:44px;border-radius:50%;background:rgba(64,158,255,0.88);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:24px;-webkit-box-shadow:0 4px 12px rgba(0,0,0,0.18);box-shadow:0 4px 12px rgba(0,0,0,0.18)\n}\n.training-media-preview__viewer[data-v-94b0b448]{position:relative;width:100%;height:100vh;background:rgba(0,0,0,0.92);overflow:hidden\n}\n.training-media-preview__viewer-close[data-v-94b0b448]{position:absolute;top:0;right:0;z-index:2003;background-color:rgba(255,255,255,0.1);padding:30px;border:0;border-radius:0 0 0 100%;cursor:pointer\n}\n.training-media-preview__viewer-close[data-v-94b0b448]:hover{background-color:rgba(255,255,255,0.2)\n}\n.training-media-preview__viewer-close i[data-v-94b0b448]{color:#fff;font-size:18px\n}\n.training-media-preview__viewer-counter[data-v-94b0b448]{position:absolute;top:10px;left:10px;z-index:2002;color:#909399;text-shadow:0 0 2px #000\n}\n.training-media-preview__viewer-counter-current[data-v-94b0b448]{font-size:22px;color:#fff\n}\n.training-media-preview__viewer-counter-total[data-v-94b0b448]{font-size:14px\n}\n.training-media-preview__viewer-body[data-v-94b0b448]{width:100%;height:calc(100% - 72px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:40px 72px 0;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.training-media-preview__viewer-image[data-v-94b0b448]{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain\n}\n.training-media-preview__viewer-video[data-v-94b0b448]{max-width:100%;max-height:100%;background:#000\n}\n.training-media-preview__viewer-nav[data-v-94b0b448]{z-index:2002\n}\n.training-media-preview__viewer-navbar[data-v-94b0b448]{position:absolute;left:0;right:0;bottom:0;z-index:2002;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:12px 16px 16px;overflow-x:auto;background:-webkit-gradient(linear, left bottom, left top, from(rgba(0,0,0,0.55)), to(transparent));background:linear-gradient(to top, rgba(0,0,0,0.55), transparent)\n}\n.training-media-preview__viewer-nav-item[data-v-94b0b448]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:56px;height:56px;border-radius:4px;overflow:hidden;cursor:pointer;opacity:0.65;border:2px solid transparent;background:rgba(255,255,255,0.08)\n}\n.training-media-preview__viewer-nav-item.is-active[data-v-94b0b448]{opacity:1;border-color:#409eff\n}\n.training-media-preview__viewer-nav-item img[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block\n}\n.training-media-preview__viewer-nav-video[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:22px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1810:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7b823748", content, true, {});

/***/ }),

/***/ 1811:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-media-preview__viewer-dialog{margin:0!important;background:transparent;-webkit-box-shadow:none;box-shadow:none}.training-media-preview__viewer-dialog .el-dialog__header{display:none}.training-media-preview__viewer-dialog .el-dialog__body{padding:0}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingMediaPreview.vue"],"names":[],"mappings":"AACA,uCAAuC,mBAAoB,uBAAuB,wBAAwB,eAAe,CACxH,AACD,0DAA0D,YAAY,CACrE,AACD,wDAAwD,SAAS,CAChE","file":"TrainingMediaPreview.vue","sourcesContent":["\n.training-media-preview__viewer-dialog{margin:0 !important;background:transparent;-webkit-box-shadow:none;box-shadow:none\n}\n.training-media-preview__viewer-dialog .el-dialog__header{display:none\n}\n.training-media-preview__viewer-dialog .el-dialog__body{padding:0\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.normalizedFiles.length)?_c('div',{staticClass:"training-media-preview"},[_c('div',{staticClass:"training-media-preview__grid"},_vm._l((_vm.normalizedFiles),function(file,index){return _c('div',{key:_vm.fileKey(file, index),staticClass:"training-media-preview__item",on:{"click":function($event){return _vm.openViewer(index)}}},[(file.type === 'img')?_c('img',{staticClass:"training-media-preview__thumb",attrs:{"src":file.url,"alt":""}}):(file.type === 'video')?_c('div',{staticClass:"training-media-preview__video"},[_vm._m(0,true),_vm._v(" "),_vm._m(1,true)]):_vm._e()])}),0),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.viewer.visible,"width":"100%","top":"0","append-to-body":"","custom-class":"training-media-preview__viewer-dialog","close-on-click-modal":false,"close-on-press-escape":true,"show-close":false},on:{"update:visible":function($event){return _vm.$set(_vm.viewer, "visible", $event)},"closed":_vm.onViewerClosed,"opened":_vm.onViewerOpened}},[(_vm.viewer.visible)?_c('div',{staticClass:"training-media-preview__viewer"},[_c('button',{staticClass:"training-media-preview__viewer-close el-dialog__headerbtn",attrs:{"type":"button"},on:{"click":_vm.closeViewer}},[_c('i',{staticClass:"el-dialog__close el-icon el-icon-close"})]),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-counter"},[_c('span',{staticClass:"training-media-preview__viewer-counter-current"},[_vm._v(_vm._s(_vm.viewerIndex + 1))]),_vm._v(" "),_c('span',{staticClass:"training-media-preview__viewer-counter-total"},[_vm._v("/"+_vm._s(_vm.normalizedFiles.length))])]),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-body"},[(_vm.activeFile && _vm.activeFile.type === 'img')?_c('img',{key:'img-' + _vm.viewerIndex,staticClass:"training-media-preview__viewer-image",attrs:{"src":_vm.activeFile.url,"alt":""}}):(_vm.activeFile && _vm.activeFile.type === 'video')?_c('video',{key:'video-' + _vm.viewerIndex,ref:"videoPlayer",staticClass:"training-media-preview__viewer-video",attrs:{"src":_vm.activeFile.url,"controls":"","autoplay":"","playsinline":""}}):_vm._e()]),_vm._v(" "),(_vm.canGoPrev)?_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__prev training-media-preview__viewer-nav",on:{"click":_vm.viewPrev}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_vm._v(" "),(_vm.canGoNext)?_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__next training-media-preview__viewer-nav",on:{"click":_vm.viewNext}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-navbar"},_vm._l((_vm.normalizedFiles),function(file,index){return _c('div',{key:'nav-' + _vm.fileKey(file, index),class:['training-media-preview__viewer-nav-item', { 'is-active': _vm.viewerIndex === index }],on:{"click":function($event){return _vm.viewIndex(index)}}},[(file.type === 'img')?_c('img',{attrs:{"src":file.url,"alt":""}}):_c('div',{staticClass:"training-media-preview__viewer-nav-video"},[_c('i',{staticClass:"el-icon-video-camera"})])])}),0)]):_vm._e()])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-media-preview__video-placeholder"},[_c('i',{staticClass:"el-icon-video-camera"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-media-preview__play-overlay"},[_c('i',{staticClass:"el-icon-video-play"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["i"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getExamStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getExamStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getExamStatusActions;
/* harmony export (immutable) */ __webpack_exports__["o"] = isExamStructureLocked;
/* harmony export (immutable) */ __webpack_exports__["l"] = isExamReadonly;
/* harmony export (immutable) */ __webpack_exports__["m"] = isExamScopeLocked;
/* harmony export (immutable) */ __webpack_exports__["n"] = isExamScoreLocked;
/* harmony export (immutable) */ __webpack_exports__["j"] = isExamAnswerLocked;
/* harmony export (immutable) */ __webpack_exports__["k"] = isExamOptionStructureLocked;
/* unused harmony export createExamQuestionClientId */
/* harmony export (immutable) */ __webpack_exports__["c"] = createExamQuestion;
/* harmony export (immutable) */ __webpack_exports__["p"] = normalizeExamQuestionFromRow;
/* unused harmony export getExamQuestionSubmitPayload */
/* harmony export (immutable) */ __webpack_exports__["h"] = getExamSubmitPayload;
/* unused harmony export TRAINING_EXAM_COPY_TYPE */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["q"] = normalizeTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getExamQuestionDuplicateKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__ = __webpack_require__(1526);






var consts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__["c" /* consts */], {
  OPEN_BOOK_EXAM_OPEN: 1,
  OPEN_BOOK_EXAM_CLOSED: 2,
  SORT_TYPE_FIXED: 1,
  SORT_TYPE_RANDOM: 2,
  RECORD_STATUS_EXAMINING: 1, // 考试中
  RECORD_STATUS_PASS: 2, // 通过
  RECORD_STATUS_UNPASS: 3 // 未通过
});

var opts = {
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__["l" /* opts */].isCommonMaps,
  InternScopeMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__["l" /* opts */].InternScopeMaps,
  statusMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__["l" /* opts */].statusMaps,
  openBookMaps: [{ value: consts.OPEN_BOOK_EXAM_OPEN, label: '开卷' }, { value: consts.OPEN_BOOK_EXAM_CLOSED, label: '闭卷' }],
  sortTypeMaps: [{ value: consts.SORT_TYPE_FIXED, label: '固定顺序' }, { value: consts.SORT_TYPE_RANDOM, label: '乱序' }],
  // 答卷状态
  recordStatusMaps: [{ value: consts.RECORD_STATUS_EXAMINING, label: '考试中' }, { value: consts.RECORD_STATUS_PASS, label: '通过' }, { value: consts.RECORD_STATUS_UNPASS, label: '未通过' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getExamStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getExamStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getExamStatusActions(status) {
  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{
        name: 'online',
        label: '上架',
        type: 'success',
        apiName: 'onlineTrainingExaminationIntern',
        successText: '上架成功'
      }];
    case consts.STATUS_ONLINE:
      return [{
        name: 'offline',
        label: '下架',
        type: 'warning',
        apiName: 'offlineTrainingExaminationIntern',
        successText: '下架成功'
      }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingExaminationIntern', successText: '作废成功' }, {
        name: 'online',
        label: '上架',
        type: 'success',
        apiName: 'onlineTrainingExaminationIntern',
        successText: '上架成功'
      }];
    case consts.STATUS_BANNED:
      return [{
        name: 'active',
        label: '激活',
        type: 'primary',
        apiName: 'activeTrainingExaminationIntern',
        successText: '激活成功'
      }];
    default:
      return [];
  }
}

function isExamStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamReadonly(status) {
  return Number(status) === consts.STATUS_BANNED;
}

function isExamScopeLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_OFFLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamScoreLocked(status) {
  return Number(status) !== consts.STATUS_NEW;
}

function isExamAnswerLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamOptionStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function createExamQuestionClientId() {
  return 'examq' + Math.random().toString(16).slice(2) + Date.now();
}

function createExamQuestion() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var questionType = Number(type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
    client_id: createExamQuestionClientId(),
    source_question_id: null,
    target_usertype: null,
    customerid: null,
    training_knowledge_id: null,
    question_type: questionType,
    title: '',
    sample_files: [],
    options: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType) ? Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["c" /* createDefaultQuestionOptions */])() : [],
    standard_answer: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: '',
    analysis_files: []
  }, overrides);
}

function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
}

// 格式化每个题目，扁平化，原因是题目组件当时重新组装了form，这里复用组件也需要重新组装一下后端或者粘贴的题目结构
function normalizeExamQuestionFromRow(row) {
  var questionJson = row.question_json || {};
  var analysis = questionJson.question_analysis || {};
  var questionType = Number(row.question_type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var standardAnswer = hasValue(questionJson.standard_answer) ? questionJson.standard_answer : row.standard_answer;

  return createExamQuestion(questionType, {
    title: row.title || questionJson.title || '',
    source_question_id: row.id || null,
    target_usertype: hasValue(row.target_usertype) ? row.target_usertype : null,
    customerid: hasValue(row.customerid) ? row.customerid : null,
    training_knowledge_id: hasValue(row.training_knowledge_id) ? row.training_knowledge_id : null,
    sample_files: Array.isArray(questionJson.sample_files) ? questionJson.sample_files : [],
    options: Array.isArray(questionJson.options) ? questionJson.options : [],
    standard_answer: hasValue(standardAnswer) ? standardAnswer : Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: analysis.analysis_text || '',
    analysis_files: Array.isArray(analysis.analysis_files) ? analysis.analysis_files : []
  });
}

// 格式化每道题目
function getExamQuestionSubmitPayload(question) {
  var questionType = Number(question.question_type);
  var questionJson = {
    title: question.title || '',
    sample_files: question.sample_files || [],
    question_analysis: {
      analysis_text: question.analysis_text || '',
      analysis_files: question.analysis_files || []
    },
    standard_answer: question.standard_answer
  };

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType)) {
    questionJson.options = question.options || [];
  }

  return {
    id: question.source_question_id || question.id || null,
    question_type: questionType,
    question_json: questionJson
  };
}

function getExamSubmitPayload(form) {
  return {
    title: form.title,
    target_usertype: String(form.target_usertype),
    is_common: Number(form.is_common),
    customerid: Number(form.customerid) || 0,
    training_knowledge_id: Number(form.training_knowledge_id),
    open_book_exam: Number(form.open_book_exam),
    question_score: Number(form.question_score),
    passing_score: Number(form.passing_score),
    exam_duration: Number(form.exam_duration),
    question_sort_type: Number(form.question_sort_type),
    question_options_sort_type: Number(form.question_options_sort_type),
    question_list: (form.question_list || []).map(function (question) {
      return getExamQuestionSubmitPayload(question);
    })
  };
}

var TRAINING_EXAM_COPY_TYPE = 'training-exam-intern';

// 复制
function buildTrainingExamCopyData(form) {
  var data = getExamSubmitPayload(form);
  return {
    version: 1,
    date: new Date().toISOString(),
    type: TRAINING_EXAM_COPY_TYPE,
    title: data.title,
    data: data
  };
}

// 粘贴
function normalizeTrainingExamCopyData(copyData) {
  if (!copyData || copyData.type !== TRAINING_EXAM_COPY_TYPE || !copyData.data) {
    return null;
  }

  var data = copyData.data;
  return {
    title: data.title || '',
    target_usertype: Number(data.target_usertype) || consts.TARGETUSER_TYPE_USER,
    is_common: Number(data.is_common || consts.IS_COMMON_DEDICATED),
    customerid: Number(data.customerid) > 0 ? String(data.customerid) : null,
    training_knowledge_id: data.training_knowledge_id || null,
    open_book_exam: Number(data.open_book_exam) || consts.OPEN_BOOK_EXAM_CLOSED,
    question_score: Number(data.question_score) || 10,
    passing_score: Number(data.passing_score) || 60,
    exam_duration: Number(data.exam_duration) || 60,
    question_sort_type: Number(data.question_sort_type) || consts.SORT_TYPE_FIXED,
    question_options_sort_type: Number(data.question_options_sort_type) || consts.SORT_TYPE_FIXED,
    question_list: Array.isArray(data.question_list) ? data.question_list.map(function (item) {
      return normalizeExamQuestionFromRow(item);
    }) : []
  };
}

// 不做前端验证，代码先保留 重复项检查比对的是选项显示的内容，而不是内部的选项 UUID
function getChoiceAnswerIndex(answer, options) {
  return options.findIndex(function (option) {
    return option.uuid === answer;
  });
}

function getChoiceDuplicateAnswer(questionType, questionJson, options) {
  if (Number(questionType) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI) {
    return (Array.isArray(questionJson.standard_answer) ? questionJson.standard_answer : []).map(function (answer) {
      return getChoiceAnswerIndex(answer, options);
    }).sort(function (prev, next) {
      return prev - next;
    });
  }
  return getChoiceAnswerIndex(questionJson.standard_answer, options);
}

function getExamQuestionDuplicateKey(question) {
  var payload = getExamQuestionSubmitPayload(question);
  var questionJson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, payload.question_json);

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(payload.question_type)) {
    var options = Array.isArray(questionJson.options) ? questionJson.options : [];
    // 取标题检测
    questionJson.options = options.map(function (option) {
      return {
        title: option.title || ''
      };
    });
    questionJson.standard_answer = getChoiceDuplicateAnswer(payload.question_type, questionJson, options);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    question_type: payload.question_type,
    question_json: questionJson
  });
}

/***/ }),

/***/ 3051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_training_training_exam_intern_constants__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_components_TrainingMediaPreview_vue__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_components_TrainingInstructionSubHeading_vue__ = __webpack_require__(1612);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingExaminationInternRecordDetail',
  components: { TrainingMediaPreview: __WEBPACK_IMPORTED_MODULE_1__views_training_components_TrainingMediaPreview_vue__["a" /* default */], TrainingInstructionSubHeading: __WEBPACK_IMPORTED_MODULE_2__views_training_components_TrainingInstructionSubHeading_vue__["a" /* default */] },
  data: function data() {
    return {
      loading: false,
      loadError: '',
      detail: { answer_list: [] },
      loadSequence: 0
    };
  },

  computed: {
    pageTitle: function pageTitle() {
      return this.detail.user_name ? '\u7B54\u5377\u8BE6\u60C5 \xB7 ' + this.detail.user_name : '答卷详情';
    },
    listPath: function listPath() {
      return '/training/examination/' + this.$route.params.examinationId + '/intern/records';
    },
    answers: function answers() {
      return this.detail.answer_list || [];
    },
    infoBlocks: function infoBlocks() {
      return [{
        title: '考生信息',
        icon: 'el-icon-user',
        rows: [{ label: '姓名', value: this.detail.user_name }, { label: '用户ID', value: this.detail.user_id }]
      }, {
        title: '考试信息',
        icon: 'el-icon-document',
        rows: [{ label: '考试名称', value: this.detail.title }, { label: '考试ID', value: this.detail.exam_id }, { label: '提交时间', value: this.detail.submitted_at }, { label: '答题用时', value: this.detail.duration_text }]
      }];
    },
    scoreCards: function scoreCards() {
      var status = Number(this.detail.status);
      var statusType = status === __WEBPACK_IMPORTED_MODULE_0__views_training_training_exam_intern_constants__["b" /* consts */].RECORD_STATUS_PASS ? 'is-pass' : status === __WEBPACK_IMPORTED_MODULE_0__views_training_training_exam_intern_constants__["b" /* consts */].RECORD_STATUS_UNPASS ? 'is-fail' : '';
      return [{ label: '状态', value: this.detail.status_name || '-', type: statusType }, { label: '总分', value: this.detail.full_score || 0, type: 'is-total' }, { label: '得分', value: this.detail.score || 0, type: 'is-pass' }, { label: '及格分', value: this.detail.passing_score || 0, type: 'is-passing' }, { label: '正确率', value: this.detail.correct_rate_text || '0%', type: 'is-rate' }];
    },
    statCards: function statCards() {
      return [{ label: '总题数', value: this.detail.question_count || 0, type: 'is-blue' }, { label: '答对题数', value: this.detail.correct_count || 0, type: 'is-green' }, { label: '答错题数', value: this.detail.wrong_count || 0, type: 'is-red' }];
    }
  },
  watch: {
    '$route.params': 'loadDetail'
  },
  created: function created() {
    this.loadDetail();
  },

  methods: {
    loadDetail: function loadDetail() {
      var _this = this;

      var sequence = ++this.loadSequence;
      var _$route$params = this.$route.params,
          recordId = _$route$params.recordId,
          examinationId = _$route$params.examinationId;

      this.loading = true;
      this.loadError = '';
      this.detail = { answer_list: [] };
      return request.common('getTrainingExaminationInternRecord', { id: recordId }).then(function (_ref) {
        var data = _ref.data;

        if (sequence !== _this.loadSequence) return;
        if (!data || Number(data.record_id) !== Number(recordId) || Number(data.exam_id) !== Number(examinationId)) {
          _this.loadError = '答卷与当前考试不匹配';
          return;
        }
        _this.detail = data;
      }).catch(function () {
        if (sequence === _this.loadSequence) _this.loadError = '答卷详情加载失败';
      }).finally(function () {
        if (sequence === _this.loadSequence) _this.loading = false;
      });
    },
    goBack: function goBack() {
      this.$router.push(this.listPath);
    },
    isGraded: function isGraded(item) {
      return item.is_correct === true || item.is_correct === false;
    },
    answerClass: function answerClass(item) {
      if (!this.isGraded(item)) return '';
      return item.is_correct ? 'is-correct' : 'is-wrong';
    },
    optionClass: function optionClass(item, option) {
      if (!this.isGraded(item)) return '';
      var keys = String(item.user_answer_text || '').split('、').map(function (key) {
        return key.trim();
      });
      if (!keys.includes(option.key)) return '';
      var standard = String(item.standard_answer_text || '').split('、').map(function (key) {
        return key.trim();
      });
      return standard.includes(option.key) ? 'is-correct' : 'is-wrong';
    },
    questionTypeClass: function questionTypeClass(item) {
      var types = { single_select: 'is-single', multi_select: 'is-multi', fill_blank: 'is-fill', 1: 'is-single', 2: 'is-multi', 3: 'is-fill' };
      return types[item.question_type] || '';
    }
  }
});

/***/ }),

/***/ 5647:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0b2de616", content, true, {});

/***/ }),

/***/ 5648:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".intern-exam-detail[data-v-13109267]{min-height:240px;color:#303133}.intern-exam-detail__card[data-v-13109267]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.intern-exam-detail__card+.intern-exam-detail__card[data-v-13109267]{margin-top:16px}.intern-exam-detail__card-header[data-v-13109267]{padding:12px 24px;border-bottom:1px solid #ebeef5;color:#606266;font-size:14px;font-weight:500}.intern-exam-detail__card-body[data-v-13109267]{padding:20px 24px}.intern-exam-detail__info-grid[data-v-13109267]{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}.intern-exam-detail__info-block[data-v-13109267]{padding:16px 18px;border:1px solid #ebeef5;border-radius:8px;background:#fafbfc}.intern-exam-detail__section-title[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin:0 0 14px;font-size:15px;font-weight:600}.intern-exam-detail__section-title i[data-v-13109267]{color:#409eff;font-size:16px}.intern-exam-detail__info-row[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px;margin-top:10px;font-size:14px;line-height:22px}.intern-exam-detail__info-label[data-v-13109267]{width:72px;-ms-flex-negative:0;flex-shrink:0;color:#909399}.intern-exam-detail__info-value[data-v-13109267]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;word-break:break-word}.intern-exam-detail__info-row:first-of-type .intern-exam-detail__info-value[data-v-13109267]{font-weight:600}.intern-exam-detail__divider[data-v-13109267]{height:1px;margin:20px 0;background:#ebeef5}.intern-exam-detail__score-grid[data-v-13109267]{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:12px}.intern-exam-detail__score-card[data-v-13109267]{padding:14px 16px;min-height:78px;border-radius:8px;background:#f5f7fa;-webkit-box-sizing:border-box;box-sizing:border-box}.intern-exam-detail__score-card.is-pass[data-v-13109267]{background:linear-gradient(135deg,#ecfdf5,#d1fae5);color:#047857}.intern-exam-detail__score-card.is-fail[data-v-13109267]{background:linear-gradient(135deg,#fef2f2,#fee2e2);color:#dc2626}.intern-exam-detail__score-card.is-total[data-v-13109267]{background:linear-gradient(135deg,#eff6ff,#dbeafe);color:#1d4ed8}.intern-exam-detail__score-card.is-passing[data-v-13109267]{background:linear-gradient(135deg,#fff7ed,#ffedd5);color:#c2410c}.intern-exam-detail__score-card.is-rate[data-v-13109267]{background:linear-gradient(135deg,#f5f3ff,#ede9fe);color:#6d28d9}.intern-exam-detail__score-label[data-v-13109267]{margin-bottom:8px;font-size:13px;opacity:.9}.intern-exam-detail__score-value[data-v-13109267]{font-size:24px;font-weight:600;line-height:1.2}.intern-exam-detail__score-value.is-text[data-v-13109267]{font-size:18px;line-height:1.35}.intern-exam-detail__stat-grid[data-v-13109267]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-top:16px}.intern-exam-detail__stat-card[data-v-13109267]{padding:14px 16px;border:1px solid #ebeef5;border-radius:8px}.intern-exam-detail__stat-label[data-v-13109267]{margin-bottom:8px;color:#909399;font-size:13px}.intern-exam-detail .is-blue[data-v-13109267]{color:#409eff}.intern-exam-detail .is-green[data-v-13109267]{color:#67c23a}.intern-exam-detail .is-red[data-v-13109267]{color:#f56c6c}.intern-exam-detail__empty[data-v-13109267]{padding:32px 0;text-align:center;color:#909399;font-size:14px}.intern-exam-detail__question[data-v-13109267]{padding:20px 0;border-bottom:1px solid #ebeef5}.intern-exam-detail__question[data-v-13109267]:first-child{padding-top:4px}.intern-exam-detail__question[data-v-13109267]:last-child{padding-bottom:4px;border-bottom:none}.intern-exam-detail__question-head[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px;margin-bottom:14px}.intern-exam-detail__question-index[data-v-13109267]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0;width:32px;height:32px;border-radius:50%;background:#f0f2f5;color:#606266;font-size:14px;font-weight:600}.intern-exam-detail__question-content[data-v-13109267]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.intern-exam-detail__question-meta[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px;color:#909399;font-size:13px}.intern-exam-detail__question-type[data-v-13109267]{display:inline-block;padding:2px 10px;border-radius:999px;background:#f3f4f6;font-size:12px;line-height:20px}.intern-exam-detail__question-type.is-single[data-v-13109267]{background:#dbeafe;color:#1d4ed8}.intern-exam-detail__question-type.is-multi[data-v-13109267]{background:#ede9fe;color:#6d28d9}.intern-exam-detail__question-type.is-fill[data-v-13109267]{background:#dcfce7;color:#15803d}.intern-exam-detail__question-title[data-v-13109267]{margin:0;font-size:15px;line-height:1.65;white-space:pre-wrap;word-break:break-word}.intern-exam-detail__result[data-v-13109267]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;-ms-flex-negative:0;flex-shrink:0;padding:8px 14px;border-radius:8px;background:#f5f7fa;color:#909399;font-size:14px;font-weight:600;white-space:nowrap}.intern-exam-detail__result.is-correct[data-v-13109267]{background:#ecfdf5;color:#047857}.intern-exam-detail__result.is-wrong[data-v-13109267]{background:#fef2f2;color:#dc2626}.intern-exam-detail__options[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px;margin:0 0 14px 44px}.intern-exam-detail__option[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 12px;border:1px solid transparent;border-radius:8px;background:#f5f7fa;font-size:14px;line-height:24px}.intern-exam-detail__option.is-correct[data-v-13109267]{border-color:#bbf7d0;background:#ecfdf5}.intern-exam-detail__option.is-correct i[data-v-13109267]{color:#047857}.intern-exam-detail__option.is-wrong[data-v-13109267]{border-color:#fecaca;background:#fef2f2}.intern-exam-detail__option.is-wrong i[data-v-13109267]{color:#dc2626}.intern-exam-detail__option-key[data-v-13109267]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0;width:24px;height:24px;border:1px solid #dcdfe6;border-radius:50%;background:#fff;color:#606266;font-size:12px}.intern-exam-detail__option-title[data-v-13109267]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;color:#606266;word-break:break-word}.intern-exam-detail__answer-block[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px;margin-left:44px}.intern-exam-detail__answer-row[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px}.intern-exam-detail__answer-label[data-v-13109267]{width:72px;-ms-flex-negative:0;flex-shrink:0;padding-top:8px;color:#909399;font-size:14px;line-height:22px}.intern-exam-detail__answer-box[data-v-13109267]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;padding:8px 14px;border:1px solid #ebeef5;border-radius:8px;background:#f5f7fa;color:#606266;font-size:14px;line-height:1.65;white-space:pre-wrap;word-break:break-word}.intern-exam-detail__answer-box.is-correct[data-v-13109267]{border-color:#bbf7d0;background:#ecfdf5;color:#047857}.intern-exam-detail__answer-box.is-wrong[data-v-13109267]{border-color:#fecaca;background:#fef2f2;color:#dc2626}.intern-exam-detail__answer-box.is-standard[data-v-13109267]{border-color:#bfdbfe;background:#eff6ff;color:#1d4ed8}.intern-exam-detail__answer-box.is-analysis[data-v-13109267]{border-color:#fde68a;background:#fffbeb;color:#92400e}.intern-exam-detail__answer-box.is-analysis p[data-v-13109267]{margin:0}.intern-exam-detail__footer[data-v-13109267]{margin:16px 0 8px;text-align:center}@media (max-width:1200px){.intern-exam-detail__score-grid[data-v-13109267]{grid-template-columns:repeat(3,minmax(0,1fr))}}@media (max-width:992px){.intern-exam-detail__info-grid[data-v-13109267]{grid-template-columns:1fr}.intern-exam-detail__score-grid[data-v-13109267]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:768px){.intern-exam-detail__card-body[data-v-13109267],.intern-exam-detail__card-header[data-v-13109267]{padding:16px}.intern-exam-detail__score-grid[data-v-13109267],.intern-exam-detail__stat-grid[data-v-13109267]{grid-template-columns:1fr}.intern-exam-detail__question-head[data-v-13109267]{-ms-flex-wrap:wrap;flex-wrap:wrap}.intern-exam-detail__result[data-v-13109267]{margin-left:44px}.intern-exam-detail__answer-block[data-v-13109267],.intern-exam-detail__options[data-v-13109267]{margin-left:0}.intern-exam-detail__answer-label[data-v-13109267]{width:56px}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/TrainingExaminationInternRecordDetail.vue"],"names":[],"mappings":"AACA,qCAAqC,iBAAiB,aAAa,CAClE,AACD,2CAA2C,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CAC/K,AACD,qEAAqE,eAAe,CACnF,AACD,kDAAkD,kBAAkB,gCAAgC,cAAc,eAAe,eAAe,CAC/I,AACD,gDAAgD,iBAAiB,CAChE,AACD,gDAAgD,aAAa,8CAAgD,QAAQ,CACpH,AACD,iDAAiD,kBAAkB,yBAAyB,kBAAkB,kBAAkB,CAC/H,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,gBAAgB,eAAe,eAAe,CAChO,AACD,sDAAsD,cAAc,cAAc,CACjF,AACD,+CAA+C,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,SAAS,gBAAgB,eAAe,gBAAgB,CAC/N,AACD,iDAAiD,WAAW,oBAAoB,cAAc,aAAa,CAC1G,AACD,iDAAiD,mBAAmB,WAAW,OAAO,YAAY,qBAAqB,CACtH,AACD,6FAA6F,eAAe,CAC3G,AACD,8CAA8C,WAAW,cAAc,kBAAkB,CACxF,AACD,iDAAiD,aAAa,8CAAgD,QAAQ,CACrH,AACD,iDAAiD,kBAAkB,gBAAgB,kBAAkB,mBAAmB,8BAA8B,qBAAqB,CAC1K,AACD,yDAAyD,mDAAqD,aAAa,CAC1H,AACD,yDAAyD,mDAAqD,aAAa,CAC1H,AACD,0DAA0D,mDAAqD,aAAa,CAC3H,AACD,4DAA4D,mDAAqD,aAAa,CAC7H,AACD,yDAAyD,mDAAqD,aAAa,CAC1H,AACD,kDAAkD,kBAAkB,eAAe,UAAU,CAC5F,AACD,kDAAkD,eAAe,gBAAgB,eAAe,CAC/F,AACD,0DAA0D,eAAe,gBAAgB,CACxF,AACD,gDAAgD,aAAa,8CAAgD,SAAS,eAAe,CACpI,AACD,gDAAgD,kBAAkB,yBAAyB,iBAAiB,CAC3G,AACD,iDAAiD,kBAAkB,cAAc,cAAc,CAC9F,AACD,8CAA8C,aAAa,CAC1D,AACD,+CAA+C,aAAa,CAC3D,AACD,6CAA6C,aAAa,CACzD,AACD,4CAA4C,eAAe,kBAAkB,cAAc,cAAc,CACxG,AACD,+CAA+C,eAAe,+BAA+B,CAC5F,AACD,2DAA2D,eAAe,CACzE,AACD,0DAA0D,mBAAmB,kBAAkB,CAC9F,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,SAAS,kBAAkB,CACvM,AACD,qDAAqD,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,oBAAoB,cAAc,WAAW,YAAY,kBAAkB,mBAAmB,cAAc,eAAe,eAAe,CAC9Y,AACD,uDAAuD,mBAAmB,WAAW,OAAO,WAAW,CACtG,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,kBAAkB,cAAc,cAAc,CAChO,AACD,oDAAoD,qBAAqB,iBAAiB,oBAAoB,mBAAmB,eAAe,gBAAgB,CAC/J,AACD,8DAA8D,mBAAmB,aAAa,CAC7F,AACD,6DAA6D,mBAAmB,aAAa,CAC5F,AACD,4DAA4D,mBAAmB,aAAa,CAC3F,AACD,qDAAqD,SAAS,eAAe,iBAAiB,qBAAqB,qBAAqB,CACvI,AACD,6CAA6C,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,QAAQ,oBAAoB,cAAc,iBAAiB,kBAAkB,mBAAmB,cAAc,eAAe,gBAAgB,kBAAkB,CACvV,AACD,wDAAwD,mBAAmB,aAAa,CACvF,AACD,sDAAsD,mBAAmB,aAAa,CACrF,AACD,8CAA8C,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,oBAAoB,CACvO,AACD,6CAA6C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,kBAAkB,6BAA6B,kBAAkB,mBAAmB,eAAe,gBAAgB,CAC/R,AACD,wDAAwD,qBAAqB,kBAAkB,CAC9F,AACD,0DAA0D,aAAa,CACtE,AACD,sDAAsD,qBAAqB,kBAAkB,CAC5F,AACD,wDAAwD,aAAa,CACpE,AACD,iDAAiD,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,oBAAoB,cAAc,WAAW,YAAY,yBAAyB,kBAAkB,gBAAgB,cAAc,cAAc,CAChZ,AACD,mDAAmD,mBAAmB,WAAW,OAAO,YAAY,cAAc,qBAAqB,CACtI,AACD,mDAAmD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,SAAS,gBAAgB,CACzO,AACD,iDAAiD,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,CACjL,AACD,mDAAmD,WAAW,oBAAoB,cAAc,gBAAgB,cAAc,eAAe,gBAAgB,CAC5J,AACD,iDAAiD,mBAAmB,WAAW,OAAO,YAAY,iBAAiB,yBAAyB,kBAAkB,mBAAmB,cAAc,eAAe,iBAAiB,qBAAqB,qBAAqB,CACxQ,AACD,4DAA4D,qBAAqB,mBAAmB,aAAa,CAChH,AACD,0DAA0D,qBAAqB,mBAAmB,aAAa,CAC9G,AACD,6DAA6D,qBAAqB,mBAAmB,aAAa,CACjH,AACD,6DAA6D,qBAAqB,mBAAmB,aAAa,CACjH,AACD,+DAA+D,QAAQ,CACtE,AACD,6CAA6C,kBAAkB,iBAAiB,CAC/E,AACD,0BACA,iDAAiD,6CAA+C,CAC/F,CACA,AACD,yBACA,gDAAgD,yBAAyB,CACxE,AACD,iDAAiD,6CAA+C,CAC/F,CACA,AACD,yBACA,kGAAkG,YAAY,CAC7G,AACD,iGAAiG,yBAAyB,CACzH,AACD,oDAAoD,mBAAmB,cAAc,CACpF,AACD,6CAA6C,gBAAgB,CAC5D,AACD,iGAAiG,aAAa,CAC7G,AACD,mDAAmD,UAAU,CAC5D,CACA","file":"TrainingExaminationInternRecordDetail.vue","sourcesContent":["\n.intern-exam-detail[data-v-13109267]{min-height:240px;color:#303133\n}\n.intern-exam-detail__card[data-v-13109267]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.intern-exam-detail__card+.intern-exam-detail__card[data-v-13109267]{margin-top:16px\n}\n.intern-exam-detail__card-header[data-v-13109267]{padding:12px 24px;border-bottom:1px solid #ebeef5;color:#606266;font-size:14px;font-weight:500\n}\n.intern-exam-detail__card-body[data-v-13109267]{padding:20px 24px\n}\n.intern-exam-detail__info-grid[data-v-13109267]{display:grid;grid-template-columns:repeat(2, minmax(0, 1fr));gap:16px\n}\n.intern-exam-detail__info-block[data-v-13109267]{padding:16px 18px;border:1px solid #ebeef5;border-radius:8px;background:#fafbfc\n}\n.intern-exam-detail__section-title[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin:0 0 14px;font-size:15px;font-weight:600\n}\n.intern-exam-detail__section-title i[data-v-13109267]{color:#409eff;font-size:16px\n}\n.intern-exam-detail__info-row[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px;margin-top:10px;font-size:14px;line-height:22px\n}\n.intern-exam-detail__info-label[data-v-13109267]{width:72px;-ms-flex-negative:0;flex-shrink:0;color:#909399\n}\n.intern-exam-detail__info-value[data-v-13109267]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;word-break:break-word\n}\n.intern-exam-detail__info-row:first-of-type .intern-exam-detail__info-value[data-v-13109267]{font-weight:600\n}\n.intern-exam-detail__divider[data-v-13109267]{height:1px;margin:20px 0;background:#ebeef5\n}\n.intern-exam-detail__score-grid[data-v-13109267]{display:grid;grid-template-columns:repeat(5, minmax(0, 1fr));gap:12px\n}\n.intern-exam-detail__score-card[data-v-13109267]{padding:14px 16px;min-height:78px;border-radius:8px;background:#f5f7fa;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.intern-exam-detail__score-card.is-pass[data-v-13109267]{background:linear-gradient(135deg, #ecfdf5, #d1fae5);color:#047857\n}\n.intern-exam-detail__score-card.is-fail[data-v-13109267]{background:linear-gradient(135deg, #fef2f2, #fee2e2);color:#dc2626\n}\n.intern-exam-detail__score-card.is-total[data-v-13109267]{background:linear-gradient(135deg, #eff6ff, #dbeafe);color:#1d4ed8\n}\n.intern-exam-detail__score-card.is-passing[data-v-13109267]{background:linear-gradient(135deg, #fff7ed, #ffedd5);color:#c2410c\n}\n.intern-exam-detail__score-card.is-rate[data-v-13109267]{background:linear-gradient(135deg, #f5f3ff, #ede9fe);color:#6d28d9\n}\n.intern-exam-detail__score-label[data-v-13109267]{margin-bottom:8px;font-size:13px;opacity:.9\n}\n.intern-exam-detail__score-value[data-v-13109267]{font-size:24px;font-weight:600;line-height:1.2\n}\n.intern-exam-detail__score-value.is-text[data-v-13109267]{font-size:18px;line-height:1.35\n}\n.intern-exam-detail__stat-grid[data-v-13109267]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:12px;margin-top:16px\n}\n.intern-exam-detail__stat-card[data-v-13109267]{padding:14px 16px;border:1px solid #ebeef5;border-radius:8px\n}\n.intern-exam-detail__stat-label[data-v-13109267]{margin-bottom:8px;color:#909399;font-size:13px\n}\n.intern-exam-detail .is-blue[data-v-13109267]{color:#409eff\n}\n.intern-exam-detail .is-green[data-v-13109267]{color:#67c23a\n}\n.intern-exam-detail .is-red[data-v-13109267]{color:#f56c6c\n}\n.intern-exam-detail__empty[data-v-13109267]{padding:32px 0;text-align:center;color:#909399;font-size:14px\n}\n.intern-exam-detail__question[data-v-13109267]{padding:20px 0;border-bottom:1px solid #ebeef5\n}\n.intern-exam-detail__question[data-v-13109267]:first-child{padding-top:4px\n}\n.intern-exam-detail__question[data-v-13109267]:last-child{padding-bottom:4px;border-bottom:none\n}\n.intern-exam-detail__question-head[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px;margin-bottom:14px\n}\n.intern-exam-detail__question-index[data-v-13109267]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0;width:32px;height:32px;border-radius:50%;background:#f0f2f5;color:#606266;font-size:14px;font-weight:600\n}\n.intern-exam-detail__question-content[data-v-13109267]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.intern-exam-detail__question-meta[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px;color:#909399;font-size:13px\n}\n.intern-exam-detail__question-type[data-v-13109267]{display:inline-block;padding:2px 10px;border-radius:999px;background:#f3f4f6;font-size:12px;line-height:20px\n}\n.intern-exam-detail__question-type.is-single[data-v-13109267]{background:#dbeafe;color:#1d4ed8\n}\n.intern-exam-detail__question-type.is-multi[data-v-13109267]{background:#ede9fe;color:#6d28d9\n}\n.intern-exam-detail__question-type.is-fill[data-v-13109267]{background:#dcfce7;color:#15803d\n}\n.intern-exam-detail__question-title[data-v-13109267]{margin:0;font-size:15px;line-height:1.65;white-space:pre-wrap;word-break:break-word\n}\n.intern-exam-detail__result[data-v-13109267]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;-ms-flex-negative:0;flex-shrink:0;padding:8px 14px;border-radius:8px;background:#f5f7fa;color:#909399;font-size:14px;font-weight:600;white-space:nowrap\n}\n.intern-exam-detail__result.is-correct[data-v-13109267]{background:#ecfdf5;color:#047857\n}\n.intern-exam-detail__result.is-wrong[data-v-13109267]{background:#fef2f2;color:#dc2626\n}\n.intern-exam-detail__options[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px;margin:0 0 14px 44px\n}\n.intern-exam-detail__option[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 12px;border:1px solid transparent;border-radius:8px;background:#f5f7fa;font-size:14px;line-height:24px\n}\n.intern-exam-detail__option.is-correct[data-v-13109267]{border-color:#bbf7d0;background:#ecfdf5\n}\n.intern-exam-detail__option.is-correct i[data-v-13109267]{color:#047857\n}\n.intern-exam-detail__option.is-wrong[data-v-13109267]{border-color:#fecaca;background:#fef2f2\n}\n.intern-exam-detail__option.is-wrong i[data-v-13109267]{color:#dc2626\n}\n.intern-exam-detail__option-key[data-v-13109267]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0;width:24px;height:24px;border:1px solid #dcdfe6;border-radius:50%;background:#fff;color:#606266;font-size:12px\n}\n.intern-exam-detail__option-title[data-v-13109267]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;color:#606266;word-break:break-word\n}\n.intern-exam-detail__answer-block[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px;margin-left:44px\n}\n.intern-exam-detail__answer-row[data-v-13109267]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px\n}\n.intern-exam-detail__answer-label[data-v-13109267]{width:72px;-ms-flex-negative:0;flex-shrink:0;padding-top:8px;color:#909399;font-size:14px;line-height:22px\n}\n.intern-exam-detail__answer-box[data-v-13109267]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;padding:8px 14px;border:1px solid #ebeef5;border-radius:8px;background:#f5f7fa;color:#606266;font-size:14px;line-height:1.65;white-space:pre-wrap;word-break:break-word\n}\n.intern-exam-detail__answer-box.is-correct[data-v-13109267]{border-color:#bbf7d0;background:#ecfdf5;color:#047857\n}\n.intern-exam-detail__answer-box.is-wrong[data-v-13109267]{border-color:#fecaca;background:#fef2f2;color:#dc2626\n}\n.intern-exam-detail__answer-box.is-standard[data-v-13109267]{border-color:#bfdbfe;background:#eff6ff;color:#1d4ed8\n}\n.intern-exam-detail__answer-box.is-analysis[data-v-13109267]{border-color:#fde68a;background:#fffbeb;color:#92400e\n}\n.intern-exam-detail__answer-box.is-analysis p[data-v-13109267]{margin:0\n}\n.intern-exam-detail__footer[data-v-13109267]{margin:16px 0 8px;text-align:center\n}\n@media (max-width: 1200px){\n.intern-exam-detail__score-grid[data-v-13109267]{grid-template-columns:repeat(3, minmax(0, 1fr))\n}\n}\n@media (max-width: 992px){\n.intern-exam-detail__info-grid[data-v-13109267]{grid-template-columns:1fr\n}\n.intern-exam-detail__score-grid[data-v-13109267]{grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n}\n@media (max-width: 768px){\n.intern-exam-detail__card-header[data-v-13109267],.intern-exam-detail__card-body[data-v-13109267]{padding:16px\n}\n.intern-exam-detail__score-grid[data-v-13109267],.intern-exam-detail__stat-grid[data-v-13109267]{grid-template-columns:1fr\n}\n.intern-exam-detail__question-head[data-v-13109267]{-ms-flex-wrap:wrap;flex-wrap:wrap\n}\n.intern-exam-detail__result[data-v-13109267]{margin-left:44px\n}\n.intern-exam-detail__options[data-v-13109267],.intern-exam-detail__answer-block[data-v-13109267]{margin-left:0\n}\n.intern-exam-detail__answer-label[data-v-13109267]{width:56px\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.pageTitle),expression:"pageTitle"},{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"intern-exam-detail"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/intern-examination' }}},[_vm._v("实习生考试管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: _vm.listPath }}},[_vm._v("实习生答卷记录")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("答卷详情")])],1)],1),_vm._v(" "),_c('training-instruction-sub-heading',{attrs:{"title":_vm.pageTitle,"entity-id":_vm.$route.params.recordId,"fallback-path":_vm.listPath}}),_vm._v(" "),(_vm.loadError)?_c('div',{staticClass:"intern-exam-detail__empty"},[_c('p',[_vm._v(_vm._s(_vm.loadError))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.loadDetail}},[_vm._v("重新加载")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回答卷列表")])],1):(_vm.detail.record_id)?[_c('section',{staticClass:"intern-exam-detail__card"},[_c('div',{staticClass:"intern-exam-detail__card-header"},[_vm._v("答卷信息")]),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__card-body"},[_c('div',{staticClass:"intern-exam-detail__info-grid"},_vm._l((_vm.infoBlocks),function(block){return _c('div',{key:block.title,staticClass:"intern-exam-detail__info-block"},[_c('h4',{staticClass:"intern-exam-detail__section-title"},[_c('i',{class:block.icon}),_vm._v(_vm._s(block.title))]),_vm._v(" "),_vm._l((block.rows),function(row){return _c('div',{key:row.label,staticClass:"intern-exam-detail__info-row"},[_c('span',{staticClass:"intern-exam-detail__info-label"},[_vm._v(_vm._s(row.label))]),_vm._v(" "),_c('span',{staticClass:"intern-exam-detail__info-value"},[_vm._v(_vm._s(row.value || '-'))])])})],2)}),0),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__divider"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__score-grid"},_vm._l((_vm.scoreCards),function(card){return _c('div',{key:card.label,class:['intern-exam-detail__score-card', card.type]},[_c('div',{staticClass:"intern-exam-detail__score-label"},[_vm._v(_vm._s(card.label))]),_vm._v(" "),_c('div',{class:['intern-exam-detail__score-value', { 'is-text': card.label === '状态' }]},[_vm._v(_vm._s(card.value))])])}),0),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__stat-grid"},_vm._l((_vm.statCards),function(card){return _c('div',{key:card.label,staticClass:"intern-exam-detail__stat-card"},[_c('div',{staticClass:"intern-exam-detail__stat-label"},[_vm._v(_vm._s(card.label))]),_vm._v(" "),_c('div',{class:['intern-exam-detail__score-value', card.type]},[_vm._v(_vm._s(card.value))])])}),0)])]),_vm._v(" "),_c('section',{staticClass:"intern-exam-detail__card"},[_c('div',{staticClass:"intern-exam-detail__card-header"},[_vm._v("答题详情（"+_vm._s(_vm.answers.length)+" 题）")]),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__card-body"},[(!_vm.answers.length)?_c('div',{staticClass:"intern-exam-detail__empty"},[_vm._v("暂无答题记录")]):_vm._e(),_vm._v(" "),_vm._l((_vm.answers),function(item,index){return _c('article',{key:item.id,staticClass:"intern-exam-detail__question"},[_c('div',{staticClass:"intern-exam-detail__question-head"},[_c('span',{staticClass:"intern-exam-detail__question-index"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__question-content"},[_c('div',{staticClass:"intern-exam-detail__question-meta"},[_c('span',{class:['intern-exam-detail__question-type', _vm.questionTypeClass(item)]},[_vm._v(_vm._s(item.question_type_name || '题目'))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.max_score)+" 分")])]),_vm._v(" "),_c('p',{staticClass:"intern-exam-detail__question-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('training-media-preview',{attrs:{"files":item.sample_files}})],1),_vm._v(" "),_c('div',{class:['intern-exam-detail__result', _vm.answerClass(item)]},[(_vm.isGraded(item))?[_c('i',{class:item.is_correct ? 'el-icon-check' : 'el-icon-close'}),_vm._v("\n                "+_vm._s(item.score > 0 ? '+' : '')+_vm._s(item.score || 0)+"分\n              ")]:_c('span',[_vm._v("未判分")])],2)]),_vm._v(" "),((item.options || []).length)?_c('div',{staticClass:"intern-exam-detail__options"},_vm._l((item.options),function(option){return _c('div',{key:option.uuid || option.key,class:['intern-exam-detail__option', _vm.optionClass(item, option)]},[_c('span',{staticClass:"intern-exam-detail__option-key"},[_vm._v(_vm._s(option.key))]),_vm._v(" "),_c('span',{staticClass:"intern-exam-detail__option-title"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(_vm.optionClass(item, option))?_c('i',{class:_vm.optionClass(item, option) === 'is-correct' ? 'el-icon-check' : 'el-icon-close'}):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__answer-block"},[_c('div',{staticClass:"intern-exam-detail__answer-row"},[_c('span',{staticClass:"intern-exam-detail__answer-label"},[_vm._v("考生答案")]),_vm._v(" "),_c('div',{class:['intern-exam-detail__answer-box', _vm.answerClass(item)]},[_vm._v(_vm._s(item.user_answer_text || '未作答'))])]),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__answer-row"},[_c('span',{staticClass:"intern-exam-detail__answer-label"},[_vm._v("正确答案")]),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__answer-box is-standard"},[_vm._v(_vm._s(item.standard_answer_text || '-'))])]),_vm._v(" "),(item.analysis_text || (item.analysis_files || []).length)?_c('div',{staticClass:"intern-exam-detail__answer-row"},[_c('span',{staticClass:"intern-exam-detail__answer-label"},[_vm._v("答案解析")]),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__answer-box is-analysis"},[(item.analysis_text)?_c('p',[_vm._v(_vm._s(item.analysis_text))]):_vm._e(),_vm._v(" "),_c('training-media-preview',{attrs:{"files":item.analysis_files}})],1)]):_vm._e()])])})],2)]),_vm._v(" "),_c('div',{staticClass:"intern-exam-detail__footer"},[_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回答卷列表")])],1)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"intern-exam-detail__section-title"},[_c('i',{staticClass:"el-icon-data-analysis"}),_vm._v("得分情况")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/training-examination-intern-record-detail.19a0c13ca8b674c87013.js